import React from 'react';
import './Button.css';
import { Link } from 'react-router-dom';

const Button = ({ title, link }) => {
  const isExternal = link.startsWith('http'); // 判斷是不是外部網址

  if (isExternal) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer" className="btn">
        {title}
      </a>
    );
  }

  return (
    <Link to={`/${link}`} className="btn">
      {title}
    </Link>
  );
};

export default Button;
